<template>
  <div class="overlay" v-if="isVisible">
    <div class="adminCreateCurriculumPop">
      <b class="createCurriculum">Create Curriculum</b>
      <div class="frameParent">
        <div class="itemParent">
          <div class="curriculumTitle">Curriculum Title</div>
          <hilo-select
            ref="title"
            theme="grey"
            placeholder="Title"
            style="width: 100%"
            :options="filteredCurriculums"
            v-model="curriculumTitle"
          ></hilo-select>
        </div>
        <div class="itemParent">
          <div class="curriculumTitle">Certificate</div>
          <hilo-select
            theme="grey"
            placeholder="Choose One"
            style="width: 100%"
            :options="programs"
            v-model="certificate"
          ></hilo-select>
        </div>
        <div class="itemParent">
          <div class="curriculumTitle">Status</div>
          <hilo-select
            theme="grey"
            placeholder="Choose One"
            style="width: 100%"
            :options="statuses"
            v-model="status"
          ></hilo-select>
        </div>
        <div class="itemParent">
          <div class="curriculumTitle">Regulation</div>
          <hilo-select
            theme="grey"
            placeholder="Choose One"
            style="width: 100%"
            :options="regulations"
            v-model="regulation"
          ></hilo-select>
        </div>
        <!--        <div class="curriculumTitleParent">
          <div class="locations">Location(s)</div>
          <div class="titleParent">
            <div class="title">Select All That Apply</div>
            <img class="vectorIcon" alt="" src="Vector.svg" />
          </div>
        </div>
        <div class="curriculumTitleParent">
          <div class="locations">Status</div>
          <div class="titleParent">
            <div class="title">Choose One</div>
            <img class="vectorIcon" alt="" src="Vector.svg" />
          </div>
        </div>
        <div class="curriculumTitleParent">
          <div class="locations">Regulation</div>
          <div class="titleParent">
            <div class="title">Choose One</div>
            <img class="vectorIcon" alt="" src="Vector.svg" />
          </div>
        </div>-->
        <div class="itemParent">
          <div class="locations">Total Flight Hours</div>
          <input class="totalWrapper" type="number" v-model="flightHours" />
        </div>
        <div class="itemParent">
          <div class="locations">Total Sim Hours</div>
          <input class="totalWrapper" type="number" v-model="simHours" />
        </div>
        <div class="itemParent">
          <div class="locations">Total Ground Hours</div>
          <input class="totalWrapper" type="number" v-model="groundHours" />
        </div>
        <div class="itemParent">
          <div class="locations">Total Debrief Hours</div>
          <input class="totalWrapper" type="number" v-model="debriefHours" />
        </div>
        <div class="itemParent">
          <div class="curriculumTitle">Logo</div>
          <div class="uploadLogoPixelsParent" @click="triggerFileInput">
            <div class="title" v-if="!logo">Upload Logo (260 x 55 Pixels)</div>
            <div class="title" v-else>{{ logo.name }}</div>
            <img
              class="materialSymbolsuploadRoundeIcon"
              alt=""
              src="/static/img/upload-blue.svg"
            />
          </div>
          <input
            type="file"
            ref="fileInput"
            @change="handleFileUpload"
            style="display: none"
          />
        </div>
        <div class="backgroundColorParent">
          <div class="curriculumTitle">Background Color</div>
          <div class="color-wrapper">
            <input type="color" v-model="color" />
          </div>
        </div>
      </div>
      <div class="continueWrapper" @click="submit">
        <b class="continue">Continue</b>
      </div>
      <img
        class="vectorIcon5"
        alt=""
        src="/static/img/grey-x.svg"
        @click="closeModal"
      />
    </div>
  </div>
</template>
<script>
import HiloSelect from "../../../../components/HiloComponents/HiloSelect.vue";
import ProgramsAPIService from "../../../../servicehandlers/ProgramsAPIService";

const programAPIService = new ProgramsAPIService();
export default {
  name: "AdminCreateCurriculumPop",
  components: { HiloSelect },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    currentCurriculums: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      curriculumTitle: null,
      certificate: null,
      flightHours: null,
      simHours: null,
      groundHours: null,
      debriefHours: null,
      logo: null,
      color: "#000",
      programs: [],
      statuses: [
        {
          id: 1,
          name: "Draft",
        },
        {
          id: 2,
          name: "Live",
        },
        {
          id: 3,
          name: "Not Active",
        },
      ],
      regulations: [
        {
          id: 1,
          name: "Part 61",
        },
        {
          id: 2,
          name: "Part 141",
        },
      ],
      status: null,
      regulation: null,
      filteredCurriculums: [],
    };
  },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.filteredCurriculums = [];
          for (let curriculum of this.currentCurriculums) {
            if (this.currentCurriculums.indexOf(curriculum) === 0) {
              this.filteredCurriculums.push({
                id: curriculum.id,
                name: curriculum.name,
              });
            } else if (
              !this.filteredCurriculums.some(
                (data) => data.name === curriculum.name,
              )
            ) {
              this.filteredCurriculums.push({
                id: curriculum.id,
                name: curriculum.name,
              });
            }
          }
        });
      }
    },
  },
  mounted() {
    this.getPrograms();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getPrograms() {
      return programAPIService.get(this.$router).then((response) => {
        this.programs = response;
      });
    },
    async submit() {
      let name;
      if (this.curriculumTitle) {
        name = this.currentCurriculums.find(
          (data) => data.id === this.curriculumTitle,
        ).name;
      } else {
        name = this.$refs.title.searchQuery;
      }

      let temp = {
        name,
        programId: this.certificate,
        description: name,
        requiredFlightHours: this.flightHours,
        requiredSimHours: this.simHours,
        requiredGroundHours: this.groundHours,
        requiredDebriefHours: this.debriefHours,
        status: this.statuses.find((data) => data.id === this.status).name,
        regulation: this.regulations.find((data) => data.id === this.regulation)
          .name,
        logo: this.logo,
        backgroundColor: this.color,
      };
      await this.$emit("create", temp);
      this.curriculumTitle = null;
      this.certificate = null;
      this.flightHours = null;
      this.simHours = null;
      this.groundHours = null;
      this.debriefHours = null;
      this.status = null;
      this.regulation = null;
      this.logo = null;
      this.color = "#000";
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      this.logo = event.target.files[0];
    },
  },
};
</script>
<style scoped>
.color-wrapper {
  width: 64px;
  height: 50px;
  overflow: hidden;
  border-radius: 10px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

input {
  width: 80px;
  height: 80px;
  background: transparent;
  padding: 0;
  flex: none;
  cursor: pointer;
}
.createCurriculum {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.curriculumTitle {
  width: 160px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.title {
  position: relative;
}
.vectorIcon {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}
.titleParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.5);
}
.itemParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.locations {
  width: 160px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.totalWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  color: black;
}
.materialSymbolsuploadRoundeIcon {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}
.uploadLogoPixelsParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
  color: #3c78ff;
  cursor: pointer;
}
.logoParent {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.frameChild {
  width: 64px;
  border-radius: 10px;
  height: 50px;
  padding: 0;
}
.backgroundColorParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
}
.continue {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.continueWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 2;
  text-align: center;
  color: #fff;
}
.vectorIcon5 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.adminCreateCurriculumPop {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
